import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

import { VendorValues } from "@app/features/catalog/client/models";

export function phoneFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const phoneRegex = /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;

    return phoneRegex.test(control.value) ? null : { phoneFormat: true };
  };
}

export function isValidVendorAllocation(allocations: VendorValues[]): boolean {
  const sum = allocations.reduce((acc, val) => acc + val.percentage, 0);
  return sum === 100;
}
